const FALLBACK_IP_ADDRESS = '0.0.0.0'

export function getRealIpAddress(headers: { [key: string]: string }): string {
  return (
    headers['x-real-ip'] ||
    headers['x-forwarded-for'] ||
    headers['x-vercel-forwarded-for'] ||
    headers['x-vercel-proxied-for'] ||
    FALLBACK_IP_ADDRESS
  )
}
